

// function DeleteUser(){  
//     return <>
//         <h1>In About</h1> 
        
    
//     </>

// }

// export default DeleteUser;


// import SideBar from "./SideBar";
import { it } from "date-fns/locale";
import { useState,useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import "./DeleteUser.css"



function DeleteUser(){  

      



        /////////

        const [email, setEmail] = useState('');
        const [name, setName] = useState('')
        const [password, setPassword] = useState(''); 
        // const {setAuth, auth} = useAuth()
        const [signUp, setSignup] = useState(false); 
        const [loginState, setLogin] = useState(true); 
        const [register, setRegister] = useState(false);
        const [Branch, setBranch] = useState("");
        const [AccNo, setAccNo] = useState("");
        const [Loading, setLoading] = useState(false);
        const [errorMsg, setErrorMsg] = useState(false);
        const [Msg, setMsg] = useState("");
        const [successMsg, setSuccessMsg] = useState(false);
        const [Gender, setGender] = useState("");
        const [Ssn, setSsn] = useState("");
        const [Compensation, setCompensation] = useState("");
        // const [position, setPosition] = useState("");
        const [mgtLvl, setMgtLevl] = useState("");
        const [address, setAddress] = useState("");
        // const [Compensation, setCompensation] = useState("");
        const[tData, setTData] = useState([]);
        const [searchData, setSearchData] = useState(""); 
        const [fildata, setFildata] = useState([]); 
        const [userData, setUserData] = useState([]); 
        // const [Ssn, setSsn] = useState("");
        // const [address, setAddress] = useState("");
        const [doh, setDoh] = useState("");
        const [FInstitution, setFInstitutionn] = useState("");
        // const [Compensation, setCompensation] = useState("");
        const [nik, setNik] = useState("");
      
        
        const [nikRel, setNikRel] = useState("");
        const [nikAddress, setNikAddress] = useState("");
        const [nikContact, setNikContact] = useState("");
        const [position, setPosition] = useState("");
        const [AccountType, setAccountType] = useState("");
        const [AccountBranch, setAccountBranch] = useState("");
          // const[tData, setTData] = useState([]);

              //Register user function
              async function registerUser(e) {  
                e.preventDefault(); 
                setLoading(true);
                setSuccessMsg(false);
                setErrorMsg(false);

             
                //  const response = await fetch("http://localhost:2001/api/userEdit",{ 
                 const response = await fetch("https://nerdayb.onrender.com/api/deleteUser",{ 
                        method : "POST",
                        headers: { 
                         "content-type" :   "application/json"
                        }, 
                        body: JSON.stringify({
                            name,
                            email,
                            Gender,
                            AccNo,
                            Compensation,
                            Ssn,
                            mgtLvl,
                            position,
                            address,
                            position,
                            doh,
                            FInstitution,
                            AccountBranch,
                            AccountType,
                            nik,
                            address,
                            nikAddress,
                            address,
                            nikContact,
                            nikRel,
                            
                        })
                        
        
                 }) 
        
                 const data = await response.json();
                 console.log(data);
        
              
        
                  if(data.status == 'Ok'){
                    // navigate("/login");

                    setPosition("");
                    setAccNo("");
                    setGender("");
                    setMgtLevl("");
                    setAddress("");
                    setCompensation("");
                    setLoading(false);
                    setEmail("");
                    setEmail("");
                    setSsn("");
                    setName("");
                    setAccNo("");
                    setAccountBranch("");
                    setAddress("");
                    setFInstitutionn(""); 
                    setDoh("");
                    setNik("");
                    setNikAddress("");
                    setNikRel("");
                    setNikContact("");
                    setPosition("");
                    setAccountType("");
                    setEmail("");
                    setGender("");
                    setCompensation("");
                    setName("");
                    setSsn("");
                    setAccNo("");
                    
                    setSuccessMsg(true)
                    setMsg(data.msg)
                    
                    // handleAuthForm()
                  }else{
                  
                    setLoading(false);
                    setMsg(data.msg)
                    setErrorMsg(true);
                  }
            }


            const handleFilter = (event) =>{ 
                console.log(event.target.value);
                const searchWord = event.target.value;
                const newFilter = searchData.filter((value)=>{
                    console.log("searchWord",searchWord)
                     return value.name.toLowerCase().includes(searchWord.toLowerCase());
                      
                })
    
                setFildata(newFilter);
           }
    
            async function populateData(){  
    
                // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
                const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
                    headers : { 
                    //   'x-access-token' : auth.user,
                    }
                // body: JSON.stringify({
                //     quote,
                    
                // })
                })
                
                const data = await response.json();
                console.log("All Data here",data.propdata)
                if(data){
    
            if(data.status == "ok") {
                setTData(data.propdata)
                setSearchData(data.propdata)
                console.log("Data here",data)
                }else{
                //    alert(data.error,"Here!")
                console.log("testign first")
                } 
    
            }
            
          //   console.log(data,"aync test");
            
            return data;
            
      } 
    
      useEffect(()=>{ 
    
         populateData();
         console.log("test populate");
    
      },[]) 
    
       const handleSelected = (item) =>{
        
                // console.log("herezz",item)
                setUserData(item)

                // console.log("User",userData)

                // name,
                // email,
                // Gender,
                    setName(item.name);
                    setEmail(item.email);
                    setGender(item.Gender);
                    setPosition(item.Position);
                    setAccNo(item.AccountNo);
                    setGender(item.Gender);
                    setMgtLevl(2);
                    setAddress("");
                    setCompensation(item.Base_Pay);
                    setSsn(item.Ssn);
                    setEmail(item.email);
                    setAccountBranch(item.AccountBranch);
                    setAddress(item.Home_address);
                    setFInstitutionn(item.FInstitution); 
                    setDoh(item.Hire_Date);
                    setNik(item.NextofKin);
                    setNikAddress(item.NextofKinAddress);
                    setNikRel(item.NextofKinRel);
                    setNikContact(item.NextofKinContact);
                    setAccountType(item.AccountType);
                    setDoh(item.Hire_Date);
                

                    // NextofKin : {
                    //     type : String,
                    //     default: ""
                        
                    //   },
                      
                    //   NextofKinRel : {
                    //     type : String,
                    //     default: ""
                        
                    //   },
                      
                    //   NextofKinAddress : {
                    //     type : String,
                    //     default: ""
                        
                    //   },
                      
                    //   NextofKinContact : {
                    //     type : String,
                    //     default: ""
                        
                    //   },
                      
                   
                   
                 




               
    
       }
            
      


    return <>
    <div className="UserMgtCover">
           
             <div>  
                 <div className="userSearch">   

                   <div className="userHeading">

                    <h2>User Management</h2>

                </div>    
                              {/* input field */}
            <div className='searchBar'>  
          
                    <div className='searchInputs'>
                        <input type="text" name='Locat' onChange = {handleFilter} />
                        <div className='ssearchIcon'> <i class="fa-solid fa-magnifying-glass"></i></div>

                        { 
                        fildata.length > 0 && 
                        (

                        <div className='dataResults'>
                        {
                        searchData && 
                        
                        fildata.map((index,key)=>{
                            
                            return (
                            <div onClick={()=>handleSelected(index)} ><a key={key} className='datItem'>{index.name}</a></div>
                            
                            )
                        
                        })} 
                    
                    </div>


                        )
                    }

                    </div>
                    </div>


                 </div>
                 <div className="UserEditCover">

                            <>

                                <br/>
                                <h3>Remove User</h3>
                                    <form onSubmit={registerUser}>
                                        {/* Name */}
                                        <div className="txt_field">
                                        <input
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Name</label>

                                        </div>
                                        {/* SSN */}
                                        <div className="txt_field">
                                        <input
                                            value={Ssn}
                                            onChange={(e) => setSsn(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>SSN</label>

                                        </div>

                                        {/* Email */}
                                        <div className="txt_field">
                                        <input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type="email"
                                            // required
                                        />
                                        <span></span>
                                        <label>Email</label>

                                        </div>
                                        {/* AccountNumber */}
                                        <div className="txt_field">
                                        <input
                                            value={AccNo}
                                            onChange={(e) => setAccNo(e.target.value)}
                                            type="number"
                                            // required
                                            disabled
                                            min={1}
                                            
                                        />
                                        <span></span>
                                        <label>Account Number</label>

                                        </div>

                                        {/* Gender */}
                                        <div className="txt_field">
                                        <input
                                            value={Gender}
                                            onChange={(e) => setGender(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Gender</label>

                                        </div>
                                        {/* Gender */}
                                        <div className="txt_field">
                                        <input
                                            value={position}
                                            onChange={(e) => setPosition(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Position</label>

                                        </div>
                                        {/* Gender */}
                                        <div className="txt_field">
                                        <input
                                            value={mgtLvl}
                                            onChange={(e) => setMgtLevl(e.target.value)}
                                            type="number"
                                            // required
                                            min={1}
                                        />
                                        <span></span>
                                        <label>Mgt Level</label>

                                        </div>
                                        {/* Gender */}
                                        <div className="txt_field">
                                        <input
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            type="text"
                                            // required
                                        />
                                        <span></span>
                                        <label>Address</label>

                                        </div>
                                        {/* Compensation */}
                                        <div  className="txt_field">

                                                <input
                                                        value={Compensation}
                                                        onChange={(e) => setCompensation(e.target.value)}
                                                        type="number"
                                                        // placeholder="Password"
                                                        // required
                                                        min={1}
                                                    />

                                                <span></span>
                                                <label>Compensation</label>

                                        </div>

                                        {/* ddddd */}
                                          {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={position}
                                            onChange={(e) => setPosition(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Position</label>

                            </div>
                     
                            <div  className="txt_field">

                                    <input
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Address</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={doh}
                                            onChange={(e) => setDoh(e.target.value)}
                                            type="date"
                                            // placeholder="Password"
                                            // required
                                          
                                        />

                                    <span></span>
                                    <label>Date of Hire</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={FInstitution}
                                            onChange={(e) => setFInstitutionn(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Financial Institution</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={AccountType}
                                            onChange={(e) => setAccountType(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Account Type</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={AccountBranch}
                                            onChange={(e) => setAccountBranch(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Account Branch</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nik}
                                            onChange={(e) => setNik(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin (NIK) Name</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikRel}
                                            onChange={(e) => setNikRel(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Relationship</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikAddress}
                                            onChange={(e) => setNikAddress(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Address</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikContact}
                                            onChange={(e) => setNikContact(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            // required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Contact</label>

                            </div>

                                        
                                        {Loading ?<div>
                                        
                                            <BeatLoader color="#36d7b7" />
                                        </div> :    
                                        <>
                                        <input className="deleteUser" type="submit" value="Delete User" />
                                    
                                            
                                            {successMsg && <div className="successMsgContainer">
                                                        
                                                        <p>{`Operation successfull! ${Msg}`}</p>
                                                        
                                            </div>}
                                            {errorMsg && <div className="errorMsgContainer">
                                                        
                                                        <p>{`Operation Failed! ${Msg}`}</p>
                                                        
                                            </div>}

                                            
                                        
                                        </>
                                        }
                                            
                                        
                                        
                                    </form>
                                <br/>
                                <br/>
                            </>

                 </div>

             </div>
             
      
               
        </div>
        
    </>

}

export default DeleteUser;

// Job Details
// Name

// Employee ID

// Position

// Gender

// Account_N0

// Base_Pay

// Management Level

// Level 1
// Employee Type

// Location

// Original Hire Date

// Contact Information - Public
// Social Security Number

// Email

// Phone Number

// Home Address